import { ChangeEvent, useId, useState } from 'react';
import classes from './Switch.module.css';
import cn from 'classnames';

type SwitchProps = {
  setParentValue: (value: boolean) => void;
  defaultState?: boolean;
  id?: string;
};

export const Switch = ({
  setParentValue,
  defaultState = false,
  id,
}: SwitchProps) => {
  // const id = useId();
  const generatedId = useId();
  const finalId = id || generatedId;
  const [switchState, setSwitchState] = useState(defaultState);

  function handleToggle(e: ChangeEvent<HTMLInputElement>) {
    setParentValue(e.target.checked);
    setSwitchState(!switchState);
  }

  const combinedToggleCircle = cn(classes.toggleCircle, {
    [classes.checkedToggleCircle]: switchState,
  });
  const combinedWrapper = cn(classes.wrapper, {
    [classes.checkedWrapper]: switchState,
  });

  return (
    <label
      htmlFor={finalId}
      className={combinedWrapper}
      role="switch"
      aria-checked={switchState}
    >
      <input
        type="checkbox"
        id={finalId}
        checked={switchState}
        onChange={handleToggle}
        className={classes.checkbox}
        aria-hidden="true"
      />
      <span className={combinedToggleCircle} />
    </label>
  );
};
